/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClimateEntry } from '../../models/climate-entry';
import { ClimateTemplatePost } from '../../models/climate-template-post';

export interface AdminClimateTemplatePost$Params {
      body: ClimateTemplatePost
}

export function adminClimateTemplatePost(http: HttpClient, rootUrl: string, params: AdminClimateTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ClimateEntry>> {
  const rb = new RequestBuilder(rootUrl, adminClimateTemplatePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClimateEntry>;
    })
  );
}

adminClimateTemplatePost.PATH = '/admin/climateTemplate';
